import React, {useState, useEffect} from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Button } from 'react-bootstrap'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { login } from '../actions/userActions'

// Module-level flag to prevent navigation loop
let hasNavigated = false

// Expose reset function for logout
window.resetLoginScreenFlags = () => {
  hasNavigated = false
}

function LoginScreen() {
    const [email,    setEmail]    = useState('')
    const [password, setPassword] = useState('')
    const dispatch   = useDispatch()
    const navigate   = useNavigate()
    const location   = useLocation()
    const userLogin  = useSelector(state => state.userLogin)
    const { loading, error, userInfo } = userLogin

    useEffect(() => {
        if (userInfo && location.pathname === '/login' && !hasNavigated) {
            hasNavigated = true
            navigate('/', { replace: true })
        }
    }, [userInfo, navigate, location])

    useEffect(() => {
        if (!userInfo) hasNavigated = false
    }, [userInfo])

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch(login(email, password))
    }

    return (
        <div style={{ minHeight: 'calc(100vh - 130px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
            <div style={{ width: '100%', maxWidth: '420px' }} className="bnb-auth-card">

                {/* ── Card header ── */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--bnb-navy) 0%, #001f5c 60%, #0a0a2e 100%)',
                    borderRadius: '10px 10px 0 0',
                    padding: '2.25rem 2rem 2rem',
                    textAlign: 'center',
                    color: '#fff',
                }}>
                    <div className="bnb-auth-icon-wrap">
                        <i className="fa-solid fa-flag bnb-auth-icon"></i>
                    </div>
                    <div className="bnb-auth-club-name">
                        <span>BNB</span> Golf Club
                    </div>
                    <div className="bnb-auth-subtitle">Sign In to your account</div>
                </div>

                {/* ── Card body ── */}
                <div className="bnb-card bnb-auth-body" style={{ borderRadius: '0 0 10px 10px', padding: '2rem' }}>
                    {error   && <Message variant="danger">{error}</Message>}
                    {loading && <Loader />}

                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-3" controlId="email">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Email Address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="password">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </Form.Group>

                        <Button
                            type="submit"
                            className="w-100"
                            style={{
                                background: 'var(--bnb-navy)', border: 'none',
                                fontWeight: '700', textTransform: 'uppercase',
                                letterSpacing: '0.08em', fontSize: '0.85rem',
                                padding: '0.65rem',
                            }}
                        >
                            Sign In
                        </Button>
                    </Form>

                    <div style={{ borderTop: '1px solid var(--bnb-border)', marginTop: '1.5rem', paddingTop: '1.25rem', textAlign: 'center', fontSize: '0.875rem', color: 'var(--bnb-gray)' }}>
                        New to BNB Golf?{' '}<br></br>Contact your club administrator to create an account.
                        {/* <Link to="/register" style={{ color: 'var(--bnb-navy)', fontWeight: '700' }}>Create account</Link> */}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default LoginScreen
